module.exports = __webpack_public_path__ + "img/xiaoshoushuju.d7377e23.png";